import Icon from '@mui/material/Icon';
import { iconName } from './iconNames';
import 'material-icons/iconfont/material-icons.css';
import colors from './colors';

export type IconProps = {
  name: iconName
  size?: number
  color?: keyof typeof colors
};

export const IconUI: React.FC<IconProps> = ({ size, name, color }) => {
  return (
    <Icon
      className="material-icons-sharp"
      style={{
        // color: target_color,
        width: size,
        height: size,
        fontSize: size,
        verticalAlign: 'middle',
        fontVariationSettings: '\'wght\' 100',
        color: color ? colors[color] : undefined,
      }}
    >
      {name}
    </Icon>
  );
};
